import React from "react";
import PropTypes from "prop-types";

const getSlugFromCountryId = (id, countries) => {
  const countryObject = countries.find(country => country.country_id === id);
  const countrySlug = countryObject.country_slug;
  return countrySlug;
};

const countryHasProfilePage = (id, countries) => {
  const countryObject = countries.find(country => country.country_id === id);
  return (countryObject.has_snapshot || countryObject.has_wd_profile) ? true : false;
};

const FooterButtons = ({ selectedCountry, currentTab, countries, cardId }) => (
    selectedCountry !== "all" ? (
      <div className="footer-wrapper">
        {countryHasProfilePage(selectedCountry, countries) &&
          <a href={`/markets/countries/${getSlugFromCountryId(selectedCountry, countries)}`}>
            <button type="button">
              Go to profile
            </button>
          </a>
        }
        <a href={`/go/download_card/${cardId}.xlsx?selectedCountryCode=${selectedCountry}&currentTab=${currentTab}`}>
          <button type="button">
            Download data
          </button>
        </a>
        {currentTab === "tariffs" &&
          <a href={`/data-hub/tariff-survey?tariff_country_name=${getSlugFromCountryId(selectedCountry, countries)}`}>
            <button type="button">
              See more tariffs
            </button>
          </a>
        }
      </div>
    ) : currentTab === "oda" &&
        <div className="footer-wrapper">
          <a href={`/go/download_card/${cardId}.xlsx?selectedCountryCode=${selectedCountry}&currentTab=${currentTab}`}>
            <button type="button">
              Download data
            </button>
          </a>
        </div>
);

export default FooterButtons;

FooterButtons.propTypes = {
  cardId: PropTypes.number.isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  currentTab: PropTypes.string.isRequired,
  selectedCountry: PropTypes.string.isRequired,
};
